webpackJsonp([15],{

/***/ "/yds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TECHNICAL_ADMINISTRATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PROJECT_MANAGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ELECTED; });
var TECHNICAL_ADMINISTRATOR = 'TECHNICAL_ADMINISTRATOR';
var PROJECT_MANAGER = 'PROJECT_MANAGER';
var CCE = 'CCE';
var USER = 'USER';
var ELECTED = 'ELECTED';

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0/R3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSVG)?_c('svg',{class:_vm.name + ' material-icons'},[_c('use',{attrs:{"xlink:href":'#'+_vm.name}})]):_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0qUu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2tzj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:['circle', _vm.backgroundClassColor]},[_c('span',{staticClass:"initials"},[_vm._v(_vm._s(_vm.initials))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "30i9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__("FRm4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbef29ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__("82cd");
function injectStyle (ssrContext) {
  __webpack_require__("5q/G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbef29ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "33oq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: {
    initials: {
      type: String,
      required: true,
      default: '?'
    },
    backgroundClassColor: {
      type: String,
      required: false,
      default: 'bg-info'
    }
  },
  components: {},
  computed: {},
  methods: {},
  watch: {},
  filters: {},
  beforeCreate: function beforeCreate() {},
  created: function created() {},
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {}
});

/***/ }),

/***/ "3m3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export commits */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_MenuItem__ = __webpack_require__("mq+R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__header_store__ = __webpack_require__("EqXW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_user__ = __webpack_require__("bREw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_counter__ = __webpack_require__("QeKQ");


var _mutations;








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* default */]);

var commits = {
  UPDATE_USER: 'UPDATE_USER',
  UPDATE_HEADER: 'UPDATE_HEADER',
  UPDATE_PUSHED_APPS: 'UPDATE_PUSHED_APPS',
  UPDATE_HEADER_NAME: 'UPDATE_HEADER_NAME',
  SET_LOADING: 'SET_LOADING'
};

var apps = [new __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_MenuItem__["a" /* default */]({ label: 'Accueil', href: '/', icon: 'home' }), new __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_MenuItem__["a" /* default */]({ label: 'Utilisateurs', href: '/user/list', key: 'UserList' }), new __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_MenuItem__["a" /* default */]({ label: 'Parcs', href: '/site/list?currentPage=1', key: 'SiteList' }), new __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_MenuItem__["a" /* default */]({ label: 'Messages', href: '/messages', key: 'MessagesIndex' }), new __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_MenuItem__["a" /* default */]({ label: 'Liens Utiles', href: '/link/list', key: 'LinkList' }), new __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_MenuItem__["a" /* default */]({ label: 'Notifications', href: '/notification/list' }), new __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_MenuItem__["a" /* default */]({ label: 'Vidéos', href: '/video/list', key: 'VideoList' }), new __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_MenuItem__["a" /* default */]({ label: 'Monitoring', href: '/monitoring', key: 'MonitoringIndex' })];

var userProfileMenu = [];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* default */].Store({
  strict: "production" !== 'production',
  state: {
    header: {},
    loading: false,
    userProfileMenu: userProfileMenu,
    apps: {
      pushed: apps,
      all: apps
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, commits.UPDATE_HEADER, function (state, header) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$log.debug('UPDATE_HEADER', header);
    state.header = header;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, commits.UPDATE_HEADER_NAME, function (state, headerName) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$log.debug('UPDATE_HEADER_NAME', headerName);

    if (state.header) {
      state.header.title = headerName;
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, commits.UPDATE_USER, function (state, user) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$log.debug('UPDATE_USER', user);
    state.user = user;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, commits.SET_LOADING, function (state, loading) {
    state.loading = loading;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, commits.UPDATE_PUSHED_APPS, function (state) {
    var that = this;
    state.apps.pushed.forEach(function (element) {
      if (element.key === 'UserList') {
        element.badge = that.getters.counters.newUsers;
      } else if (element.key === 'UnreadMessageBySite') {
        element.badge = that.getters.counters.newMessages;
      }
    });
  }), _mutations),
  getters: {
    userProfileMenu: function userProfileMenu(state) {
      return state.userProfileMenu;
    },
    header: function header(state) {
      return state.header;
    },
    pushedApps: function pushedApps(state) {
      return state.apps.pushed;
    },
    apps: function apps(state) {
      return state.apps.rest;
    }
  },
  actions: {
    setBadges: function setBadges(_ref) {
      var commit = _ref.commit;

      commit(commits.UPDATE_PUSHED_APPS);
    }
  },
  modules: {
    header: __WEBPACK_IMPORTED_MODULE_4__header_store__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_5__modules_user__["a" /* default */],
    counter: __WEBPACK_IMPORTED_MODULE_6__modules_counter__["a" /* default */]
  }
}));


/***/ }),

/***/ "5lwn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

var svgIcons = ['icon-solar-cloudy', 'icon-plant-id', 'icon-key-figures', 'icon-tag', 'icon-calendar', 'icon-stop-logbook', 'icon-contracts-db', 'icon-reporter', 'icon-data', 'shape-smile', 'shape-smile-high', 'shape-smile-medium', 'shape-smile-low', 'shape-smile-good', 'icon-handle', 'icon-pin', 'icon-notification', 'icon-arrow-back', 'icon-wind-force', 'icon-wind', 'icon-hydro', 'icon-solar', 'icon-reglages', 'icon-power', 'icon-compass', 'icon-intrusion', 'icon-oil', 'icon-last-stop', 'icon-point', 'icon-data-extractor', 'icon-alarms', 'shape-solar', 'shape-water-turbine', 'shape-wind-turbine', 'icon-pales', 'icon-hydro', 'icon-solar', 'icon-toggle-off', 'icon-toggle-on'];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Icon',
  props: {
    name: { type: String, required: true }
  },
  computed: {
    isSVG: function isSVG() {
      return svgIcons.indexOf(this.name) !== -1;
    }
  },
  methods: {
    svgIconList: function svgIconList() {
      return svgIcons;
    }
  }
});

/***/ }),

/***/ "5q/G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "82cd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.actions.length > 0)?_c('ul',{staticClass:"headerNavigation"},_vm._l((_vm.actions),function(item,index){return _c('li',{key:index,staticClass:"item"},[_c('router-link',{class:['items-navig', item.isActive() ? 'active-item' : ''],attrs:{"to":item.href}},[_vm._v(_vm._s(item.label))])],1)})):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Yka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COUNTER_UPDATE; });
var COUNTER_UPDATE = 'COUNTER_UPDATE';

/***/ }),

/***/ "AqYs":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "BIVg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defineAbilitiesFor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__casl_ability__ = __webpack_require__("ZF0n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_enums_user_role__ = __webpack_require__("/yds");



function defineAbilitiesFor(role) {
  return __WEBPACK_IMPORTED_MODULE_0__casl_ability__["a" /* AbilityBuilder */].define(function (can, cannot) {
    switch (role) {
      case __WEBPACK_IMPORTED_MODULE_1__lib_enums_user_role__["a" /* TECHNICAL_ADMINISTRATOR */]:
        can(['create', 'update', 'delete', 'lock', 'export'], 'User');
        can(['export'], 'Site');
        can(['delete', 'create'], 'Site');
        can(['export'], 'Message');
        can(['export', 'create', 'delete'], 'Notification');
        can(['sync'], 'Ampere');
        can(['create', 'update'], 'Video');
        can(['create', 'delete'], 'Link');
        break;
      case __WEBPACK_IMPORTED_MODULE_1__lib_enums_user_role__["b" /* USER */]:
        break;
      // case FUNCTIONAL_ADMINISTRATOR:
      // can(['create', 'update', 'delete'], 'User')
      // cannot(['update', 'delete'], 'User', {role: {code: 'TECHNICAL_ADMINISTRATOR'}})
      // break
      case __WEBPACK_IMPORTED_MODULE_1__lib_enums_user_role__["c" /* PROJECT_MANAGER */]:
        // can('read', 'Post')
        break;
      case __WEBPACK_IMPORTED_MODULE_1__lib_enums_user_role__["d" /* CCE */]:
        // can('read', 'Post')
        break;
    }
  });
}

/***/ }),

/***/ "BVXj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DEPO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{class:['alert-component', _vm.visible ? 'visible' : '', _vm.alert.priority]},[_c('h2',[_vm._v(_vm._s(_vm.alert.title))]),_vm._v(" "),(_vm.alert.description)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.alert.description)}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"close",on:{"click":function($event){_vm.close()}}},[_c('icon',{attrs:{"name":"close"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EZ3B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EqXW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export commits */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_transfer_objects_NavigationItem__ = __webpack_require__("SoRj");


var _mutations;



var commits = {
  UPDATE_TITLE: 'update-title',
  UPDATE_BACK: 'update-back',
  UPDATE_NAVIGATION: 'update-navigation'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    title: undefined,
    image: undefined,
    back: undefined,
    navigation: []
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, commits.UPDATE_BACK, function (state, payload) {
    if (payload.back !== undefined && !(payload.back instanceof __WEBPACK_IMPORTED_MODULE_1__lib_transfer_objects_NavigationItem__["a" /* default */])) {
      throw new Error('back must be a NavigationItem instance');
    }
    state.back = payload.back;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, commits.UPDATE_TITLE, function (state, payload) {
    // if (payload.back !== undefined && !(payload.back instanceof NavigationItem)) {
    //   throw new Error('back must be a NavigationItem instance')
    // }

    state.title = payload.title;
    state.image = payload.image;
    // state.back = payload.back
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, commits.UPDATE_NAVIGATION, function (state, navigation) {
    if (!(navigation instanceof Array)) {
      throw new Error('Navigation must be an array !');
    }

    navigation.forEach(function (item) {
      if (!(item instanceof __WEBPACK_IMPORTED_MODULE_1__lib_transfer_objects_NavigationItem__["a" /* default */])) {
        throw new Error('Navigation items must be NavigationItem instances !');
      }
    });

    state.navigation = navigation;
  }), _mutations),
  getters: {
    title: function title(state) {
      return state.title;
    },
    image: function image(state) {
      return state.image;
    },
    back: function back(state) {
      return state.back;
    },
    navigation: function navigation(state) {
      return state.navigation;
    }
  },
  actions: {
    setHeaderTitle: function setHeaderTitle(_ref, payload) {
      var commit = _ref.commit;

      if (typeof payload === 'string') {
        commit(commits.UPDATE_TITLE, { title: payload });
        return;
      }
      commit(commits.UPDATE_TITLE, payload);
    },
    setHeaderBack: function setHeaderBack(_ref2, payload) {
      var commit = _ref2.commit;

      commit(commits.UPDATE_BACK, payload);
    },
    setHeaderNavigation: function setHeaderNavigation(_ref3, payload) {
      var commit = _ref3.commit;

      commit(commits.UPDATE_NAVIGATION, payload);
    }
  }
});



/***/ }),

/***/ "FRm4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_transfer_objects_NavigationItem_js__ = __webpack_require__("SoRj");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Navigation',
  props: {
    actions: {
      type: Array,
      required: true,
      validator: function validator(value) {
        value.forEach(function (item) {
          if (!(item instanceof __WEBPACK_IMPORTED_MODULE_0__lib_transfer_objects_NavigationItem_js__["a" /* default */])) {
            throw new Error('Action list must be an array of NavigationItem objects.');
          }
        });
        return true;
      }
    }
  }
});

/***/ }),

/***/ "If3g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['drawer-menu', _vm.isActive ? 'active' : '']},[_c('a',{class:['logo', _vm.hasApps ? 'hamburger' : ''],attrs:{"href":"#"},on:{"click":_vm.toggleActive}},[_c('img',{staticClass:"shape-darwin-logo",attrs:{"src":__webpack_require__("AqYs"),"alt":"Engie Green"}})]),_vm._v(" "),(_vm.apps && _vm.apps.length>0)?_c('ul',[_c('li',{staticClass:"close",on:{"click":_vm.toggleActive}},[_vm._m(0)]),_vm._v(" "),_vm._l((_vm.apps),function(menu,index){return _c('li',{key:index,class:[menu.hasSubMenu() ? 'with-submenu' : '']},[_c('a',{attrs:{"href":menu.href}},[(menu.icon)?_c('icon',{attrs:{"name":menu.icon}}):_vm._e(),_c('span',[_vm._v(_vm._s(menu.label))])],1),_vm._v(" "),(menu.hasSubMenu())?_c('ul',_vm._l((menu.subMenu),function(sub,subIndex){return _c('li',{key:index+subIndex},[_c('a',{attrs:{"href":sub.href}},[(sub.icon)?_c('icon',{attrs:{"name":sub.icon}}):_vm._e(),_c('span',[_vm._v(_vm._s(sub.label))])],1)])})):_vm._e()])})],2):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-icon"},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jeu4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIGH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MEDIUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GOOD; });

var HIGH = 'high';
var MEDIUM = 'medium';
var GOOD = 'good';

/***/ }),

/***/ "LuU4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94bdd53e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("zb8x");
function injectStyle (ssrContext) {
  __webpack_require__("LuU4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94bdd53e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MNFy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_filters_user_role__ = __webpack_require__("XI70");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_enums_user_role__ = __webpack_require__("/yds");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_filters_user_status__ = __webpack_require__("YgsI");






var User = function () {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(User, null, [{
    key: 'modelName',
    get: function get() {
      return 'User'; // Fait le lien avec src\resources\ability.js
    }
  }]);

  function User(_ref) {
    var uid = _ref.uid,
        cityName = _ref.cityName,
        departmentNumber = _ref.departmentNumber,
        departmentName = _ref.departmentName,
        creationDate = _ref.creationDate,
        lastLoginDate = _ref.lastLoginDate,
        validationDate = _ref.validationDate,
        version = _ref.version,
        username = _ref.username,
        firstname = _ref.firstname,
        lastname = _ref.lastname,
        email = _ref.email,
        cityId = _ref.cityId,
        phoneNumber = _ref.phoneNumber,
        insee = _ref.insee,
        role = _ref.role,
        status = _ref.status,
        favorites = _ref.favorites,
        rolesManager = _ref.rolesManager;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, User);

    this.uid = uid;
    this.cityName = cityName;
    this.departmentNumber = departmentNumber;
    this.departmentName = departmentName;
    this.creationDate = creationDate;
    this.lastLoginDate = lastLoginDate;
    this.validationDate = validationDate;
    this.version = version;
    this.username = username;
    this.firstname = firstname;
    this.lastname = lastname;
    this.email = email;
    this.cityId = cityId;
    this.favoriteSites = favorites;
    this.insee = insee;
    this.phoneNumber = phoneNumber;
    this.role = {
      code: role,
      libelle: __WEBPACK_IMPORTED_MODULE_2__lib_filters_user_role__["c" /* userRole */][role]
    };
    this.status = {
      code: status,
      libelle: __WEBPACK_IMPORTED_MODULE_4__lib_filters_user_status__["b" /* userStatus */][status]
    };
    this.rolesManager = rolesManager;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(User, [{
    key: 'equal',
    value: function equal(uid) {
      return this.uid === uid;
    }
  }, {
    key: 'initials',
    value: function initials() {
      if (this.lastname && this.firstname) {
        return (this.lastname.charAt(0) + this.firstname.charAt(0)).toUpperCase();
      } else {
        return '?';
      }
    }
  }, {
    key: 'isBackOfficeAllowed',
    value: function isBackOfficeAllowed() {
      return User.BACK_OFFICE_ALLOWED_ROLES.includes(this.role.code);
    }
  }]);

  return User;
}();

User.BACK_OFFICE_ALLOWED_ROLES = [__WEBPACK_IMPORTED_MODULE_3__lib_enums_user_role__["b" /* USER */], __WEBPACK_IMPORTED_MODULE_3__lib_enums_user_role__["a" /* TECHNICAL_ADMINISTRATOR */], __WEBPACK_IMPORTED_MODULE_3__lib_enums_user_role__["c" /* PROJECT_MANAGER */], __WEBPACK_IMPORTED_MODULE_3__lib_enums_user_role__["d" /* CCE */]];
/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_main__ = __webpack_require__("3m3e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_material_design_icons_styles_css__ = __webpack_require__("siN1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_material_design_icons_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_material_design_icons_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generics_Icon__ = __webpack_require__("fvcU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_cookies__ = __webpack_require__("ppUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__casl_vue__ = __webpack_require__("cc8p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_transfer_objects_User__ = __webpack_require__("MNFy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_actions_user__ = __webpack_require__("yLEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_enums_events_app__ = __webpack_require__("u2BP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_Pluralize__ = __webpack_require__("nxk6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_Pluralize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__modules_Pluralize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_dateformat__ = __webpack_require__("CqLJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_dateformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_dateformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_search_select_dist_VueSearchSelect_css__ = __webpack_require__("aS2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_search_select_dist_VueSearchSelect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_search_select_dist_VueSearchSelect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_select_dist_vue_select_css__ = __webpack_require__("R870");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_select_dist_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_select_dist_vue_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__okta_okta_auth_js__ = __webpack_require__("fqKN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__okta_okta_auth_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__okta_okta_auth_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__okta_okta_vue__ = __webpack_require__("3t5S");



// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.























__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('v-select', __WEBPACK_IMPORTED_MODULE_21_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$isDev = "production" === 'development';
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$dateFormat = __WEBPACK_IMPORTED_MODULE_19_dateformat___default.a;
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$_ = __WEBPACK_IMPORTED_MODULE_17_lodash___default.a;
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$axios = __WEBPACK_IMPORTED_MODULE_16_axios___default.a;
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$pluralize = __WEBPACK_IMPORTED_MODULE_18__modules_Pluralize___default.a;
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$bus = __WEBPACK_IMPORTED_MODULE_8__event_bus__["a" /* default */];

var oktaAuth = new __WEBPACK_IMPORTED_MODULE_23__okta_okta_auth_js__["OktaAuth"]({
  issuer: "https://egn.okta-emea.com/oauth2/aus5yug8asNLIrGao0i7",
  clientId: "0oa5x1qjtaggMCEUK0i7",
  redirectUri: window.location.origin + '/callback',
  scopes: ['openid', 'profile', 'email']
});

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_25__okta_okta_vue__["a" /* default */], { oktaAuth: oktaAuth });

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use({
  install: function install(vue) {
    var _this = this;

    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var axiosAdminConfig = {
      baseURL: "https://frren-fc-hq-api-management.azure-api.net/backoffice/api/prod",
      timeout: 300000
    };
    vue.prototype.$administrationApi = __WEBPACK_IMPORTED_MODULE_16_axios___default.a.create(axiosAdminConfig);
    vue.prototype.$auth.isAuthenticated().then(function (response) {
      if (response === true) {
        vue.prototype.$administrationApi.interceptors.request.use(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(config) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return vue.prototype.$auth.getUser().then(function (response) {
                      config.headers = {
                        'Authorization': 'Bearer ' + vue.prototype.$auth.getAccessToken(),
                        'username': response.preferred_username
                      };
                    });

                  case 2:
                    return _context.abrupt('return', config);

                  case 3:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function (_x2) {
            return _ref.apply(this, arguments);
          };
        }(), function (error) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
        });
        vue.prototype.$administrationApi.get('users/me').then(function (response) {
          try {
            var userData = response.data;
            var user = new __WEBPACK_IMPORTED_MODULE_13__lib_transfer_objects_User__["a" /* default */](userData);
            if (!user.isBackOfficeAllowed) {
              if (__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].history.current.name !== 'MonitoringIndex') {
                __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'NotAllowed' });
              }
            }
            __WEBPACK_IMPORTED_MODULE_7__store_main__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_14_actions_user__["a" /* USER_REQUEST */], user);
            __WEBPACK_IMPORTED_MODULE_8__event_bus__["a" /* default */].$emit(__WEBPACK_IMPORTED_MODULE_15__lib_enums_events_app__["a" /* REFRESH_ABILITIES */], user);
          } catch (error) {
            if (__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].history.current.name !== 'MonitoringIndex') {
              console.error('unable to retrieve current user', error);
              __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'NotAllowed' });
            }
          }
        }).catch(function (error) {
          if (__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].history.current.name !== 'MonitoringIndex') {
            console.error('unable to retrieve current user', error);
            __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'NotAllowed' });
          }
        });
      }
    });
  }
});

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12__casl_vue__["a" /* abilitiesPlugin */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_cookies___default.a);
// Load global components
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('Icon', __WEBPACK_IMPORTED_MODULE_10__components_generics_Icon__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('Can', __WEBPACK_IMPORTED_MODULE_12__casl_vue__["b" /* Can */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].config.productionTip = false;
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]({
  el: '#main-app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store_main__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] }
});

/***/ }),

/***/ "P3x6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"alert-container"},_vm._l((_vm.alerts),function(alert,key){return _c('alert-component',{key:alert.id,attrs:{"alert":alert},on:{"remove":function($event){_vm.$delete(_vm.alerts, key)}}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QeKQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_counter__ = __webpack_require__("8Yka");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");




// import User from '@/lib/transfer-objects/User'
// import EventBus from '@/event-bus'

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* default */]);

var state = {
  counters: {
    newUsers: 0,
    newMessages: 0
  }
};

var getters = {
  counters: function counters(state) {
    return state.counters;
  }
};

var actions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__actions_counter__["a" /* COUNTER_UPDATE */], function (_ref, _ref2) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;
  var _ref2$newUsers = _ref2.newUsers,
      newUsers = _ref2$newUsers === undefined ? 0 : _ref2$newUsers,
      _ref2$newMessages = _ref2.newMessages,
      newMessages = _ref2$newMessages === undefined ? 0 : _ref2$newMessages;

  commit(__WEBPACK_IMPORTED_MODULE_1__actions_counter__["a" /* COUNTER_UPDATE */], { newUsers: newUsers, newMessages: newMessages });
});

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__actions_counter__["a" /* COUNTER_UPDATE */], function (state, _ref3) {
  var newUsers = _ref3.newUsers,
      newMessages = _ref3.newMessages;

  state.counters.newUsers = newUsers;
  state.counters.newMessages = newMessages;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "R870":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R939":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertContainer_vue__ = __webpack_require__("w+5m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f41b0802_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertContainer_vue__ = __webpack_require__("P3x6");
function injectStyle (ssrContext) {
  __webpack_require__("uCnY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f41b0802_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SCOE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SYh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SoRj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var NavigationItem = function () {
  function NavigationItem(_ref) {
    var label = _ref.label,
        href = _ref.href,
        _ref$active = _ref.active,
        active = _ref$active === undefined ? false : _ref$active,
        _ref$params = _ref.params,
        params = _ref$params === undefined ? null : _ref$params,
        _ref$query = _ref.query,
        query = _ref$query === undefined ? null : _ref$query;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NavigationItem);

    this.label = label;
    this.href = href;
    this.active = active;
    this.params = params;
    this.query = query;
    // Définition d'un alias de text vers label
    Object.defineProperty(this, 'text', {
      get: function get() {
        return this.label;
      },
      enumerable: true,
      configurable: true
    });
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NavigationItem, [{
    key: 'isActive',
    value: function isActive() {
      return this.active === true;
    }
  }]);

  return NavigationItem;
}();

/* harmony default export */ __webpack_exports__["a"] = (NavigationItem);

/***/ }),

/***/ "SwXt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawerMenu_vue__ = __webpack_require__("byCn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_467ed23d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawerMenu_vue__ = __webpack_require__("If3g");
function injectStyle (ssrContext) {
  __webpack_require__("0qUu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawerMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_467ed23d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawerMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UNZ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_user__ = __webpack_require__("yLEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LetterAvatar__ = __webpack_require__("infm");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PushedMenu',
  components: {
    LetterAvatar: __WEBPACK_IMPORTED_MODULE_5__components_LetterAvatar__["a" /* default */]
  },
  data: function data() {
    return {
      user: null,
      currentPushedApps: [],
      allPushedApps: []
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({ pushedApps: 'pushedApps', currentUser: 'user' })),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])([__WEBPACK_IMPORTED_MODULE_4__store_actions_user__["b" /* USER_LOGOUT */]]), {
    logout: function logout() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.USER_LOGOUT();
                _context.next = 3;
                return _this.$auth.signOut();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    updateMenu: function updateMenu() {
      var _this2 = this;

      this.allPushedApps.forEach(function (element) {
        if (_this2.user.role.code === 'PROJECT_MANAGER' || _this2.user.role.code === 'CCE') {
          if (element.key !== 'UserList') {
            _this2.currentPushedApps.push(element);
          }
        } else {
          if (_this2.user.role.code === 'USER') {
            if (element.key === 'MessagesIndex') {
              _this2.currentPushedApps.push(element);
            }
          } else {
            _this2.currentPushedApps.push(element);
          }
        }
      });
    }
  }),
  watch: {
    currentUser: {
      deep: true,
      immediate: true,
      handler: function handler(newVal) {
        this.user = newVal;
        this.updateMenu();
      }
    },
    pushedApps: {
      deep: true,
      immediate: true,
      handler: function handler(newVal) {
        this.allPushedApps = newVal;
      }
    }
  }
});

/***/ }),

/***/ "UV+H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_user__ = __webpack_require__("yLEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LetterAvatar__ = __webpack_require__("infm");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserMenu',
  components: {
    LetterAvatar: __WEBPACK_IMPORTED_MODULE_5__components_LetterAvatar__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])([__WEBPACK_IMPORTED_MODULE_4__store_actions_user__["b" /* USER_LOGOUT */]]), {
    logout: function logout() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.USER_LOGOUT();
                _context.next = 3;
                return _this.$auth.signOut();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['user', 'userProfileMenu']))
});

/***/ }),

/***/ "Usg1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),

/***/ "XI70":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return keyValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return select; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_enums_user_role__ = __webpack_require__("/yds");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_transfer_objects_Option__ = __webpack_require__("gXmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_Filter__ = __webpack_require__("xTyH");


var _keyValues;





var keyValues = (_keyValues = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_keyValues, __WEBPACK_IMPORTED_MODULE_1__lib_enums_user_role__["a" /* TECHNICAL_ADMINISTRATOR */], 'Administrateur'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_keyValues, __WEBPACK_IMPORTED_MODULE_1__lib_enums_user_role__["c" /* PROJECT_MANAGER */], 'Chef de Projet / Exploitation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_keyValues, __WEBPACK_IMPORTED_MODULE_1__lib_enums_user_role__["d" /* CCE */], 'CCE'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_keyValues, __WEBPACK_IMPORTED_MODULE_1__lib_enums_user_role__["b" /* USER */], 'Utilisateur'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_keyValues, __WEBPACK_IMPORTED_MODULE_1__lib_enums_user_role__["e" /* ELECTED */], 'Elu'), _keyValues);

var options = [];
for (var key in keyValues) {
  options.push(new __WEBPACK_IMPORTED_MODULE_2__lib_transfer_objects_Option__["a" /* default */](keyValues[key], key));
}
var filter = new __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_Filter__["a" /* default */]({ options: options });
var select = new __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_Filter__["a" /* default */]({ firstOptionText: 'Sélectionner un profil', options: options });



/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__okta_okta_vue__ = __webpack_require__("3t5S");





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
var metaRequireAuth = {
  requireAuth: true
};

var routes = [{
  path: '/',
  name: 'Home',
  component: function component() {
    return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "26dS"));
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/callback',
  component: __WEBPACK_IMPORTED_MODULE_3__okta_okta_vue__["b" /* LoginCallback */]
}, {
  path: '/user/list',
  name: 'UserList',
  props: function props(route) {
    return { currentPage: route.query.currentPage };
  },
  component: function component() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "r9yl"));
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/link/list',
  name: 'LinkList',
  component: function component() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "1dbB"));
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/link/:linkId',
  name: 'LinkDetails',
  component: function component() {
    return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "IBO8"));
  },
  meta: {
    breadcrumb: { name: 'SiteList', text: 'Retour aux liens' },
    requiresAuth: true
  }
}, {
  path: '/site/list',
  name: 'SiteList',
  component: function component() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "6vr0"));
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/site/:siteId',
  name: 'SiteDetails',
  component: function component() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "xuTQ"));
  },
  meta: {
    breadcrumb: { name: 'SiteList', text: 'Retour aux parcs' },
    requiresAuth: true
  }
}, {
  path: '/user/:userId',
  name: 'UserDetails',
  component: function component() {
    return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "RUe5"));
  },
  meta: {
    breadcrumb: { name: 'UserList', text: 'Retour aux utilisateurs' },
    requiresAuth: true
  }
}, {
  path: '/video/list',
  name: 'VideoList',
  component: function component() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "hUB7"));
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/messages',
  name: 'MessagesIndex',
  component: function component() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "Va3K"));
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/monitoring',
  name: 'MonitoringIndex',
  component: function component() {
    return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "srbB"));
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/notification/list',
  name: 'NotificationsList',
  component: function component() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "B8Pa"));
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/notification/:notificationId',
  name: 'NotificationDetails',
  component: function component() {
    return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "wAd3"));
  },
  meta: {
    breadcrumb: { name: 'NotificationsList', text: 'Retour aux notifications' },
    requiresAuth: true
  }
}, {
  name: 'Logout',
  path: '/Logout'
}, {
  path: '*',
  name: 'NotFound',
  component: function component() {
    return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "UG3e"));
  }
}, {
  path: '/forbiddenAccess',
  name: 'NotAllowed',
  component: function component() {
    return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "nM9Y"));
  }
}];

function SetMeta(route) {
  if (!route.meta) {
    route.meta = metaRequireAuth;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(route.meta, metaRequireAuth);
  }
}
routes.forEach(function (route) {
  if (!['NotAllowed', 'Logout'].includes(route.name)) {
    SetMeta(route);
    if (route.children) {
      route.children.forEach(function (children) {
        SetMeta(children);
      });
    }
  }
});

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YgsI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return keyValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_enums_user_status__ = __webpack_require__("xyfb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_transfer_objects_Option__ = __webpack_require__("gXmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_Filter__ = __webpack_require__("xTyH");


var _keyValues;





var keyValues = (_keyValues = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_keyValues, __WEBPACK_IMPORTED_MODULE_1__lib_enums_user_status__["a" /* VALIDATION_PENDING */], 'En attente de validation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_keyValues, __WEBPACK_IMPORTED_MODULE_1__lib_enums_user_status__["b" /* VALIDATED */], 'Validé'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_keyValues, __WEBPACK_IMPORTED_MODULE_1__lib_enums_user_status__["c" /* LOCKED */], 'Bloqué'), _keyValues);
var options = [];
for (var key in keyValues) {
  options.push(new __WEBPACK_IMPORTED_MODULE_2__lib_transfer_objects_Option__["a" /* default */](keyValues[key], key));
}
var filter = new __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_Filter__["a" /* default */]({ options: options });



/***/ }),

/***/ "ZGzS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopBar_vue__ = __webpack_require__("oO4G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_188e08ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopBar_vue__ = __webpack_require__("noix");
function injectStyle (ssrContext) {
  __webpack_require__("EZ3B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_188e08ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aS2V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b67i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PushedMenu_vue__ = __webpack_require__("UNZ5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1830eb3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PushedMenu_vue__ = __webpack_require__("nyIQ");
function injectStyle (ssrContext) {
  __webpack_require__("da/h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PushedMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1830eb3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PushedMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bREw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_user__ = __webpack_require__("yLEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");


var _actions, _mutations;




// import User from '@/lib/transfer-objects/User'
// import EventBus from '@/event-bus'

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* default */]);

var state = {
  status: '',
  // profile: {},
  user: null
};

var getters = {
  user: function user(state) {
    return state.user;
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__actions_user__["a" /* USER_REQUEST */], function (_ref, user) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  commit(__WEBPACK_IMPORTED_MODULE_1__actions_user__["c" /* USER_SUCCESS */], user);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__actions_user__["b" /* USER_LOGOUT */], function (_ref2) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  commit(__WEBPACK_IMPORTED_MODULE_1__actions_user__["b" /* USER_LOGOUT */]);
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions_user__["a" /* USER_REQUEST */], function (state) {
  state.status = 'loading';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions_user__["c" /* USER_SUCCESS */], function (state, user) {
  state.status = 'success';
  state.user = user;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions_user__["d" /* USER_ERROR */], function (state) {
  state.status = 'error';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions_user__["b" /* USER_LOGOUT */], function (state) {
  state.user = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "byCn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DrawerMenu',
  data: function data() {
    return {
      isActive: false
    };
  },
  methods: {
    toggleActive: function toggleActive() {
      this.isActive = !this.isActive;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({ apps: 'apps' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({ hasApps: function hasApps(state) {
      return state.apps && state.apps.rest && state.apps.rest.length > 0;
    } }))
});

/***/ }),

/***/ "cyJc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "da/h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fvcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("5lwn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2999ec38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("0/R3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2999ec38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gFaA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"user-menu d-lg-block d-none"},[_c('li',{staticClass:"profile"},[_c('a',{attrs:{"href":"#"}},[(_vm.user)?_c('LetterAvatar',{staticClass:"profile-picture",attrs:{"initials":_vm.user.initials()}}):_vm._e(),_vm._v(" "),(_vm.user && _vm.user.role)?_c('span',[_vm._v(_vm._s(_vm.user.lastname)+" "+_vm._s(_vm.user.firstname)),_c('br'),_vm._v("\n      ("+_vm._s(_vm.user.role.libelle)+")")]):_vm._e()],1),_vm._v(" "),_c('ul',{staticClass:"profile-menu"},[_vm._l((_vm.userProfileMenu),function(menu,index){return _c('li',{key:index},[_c('a',{attrs:{"href":menu.href}},[(menu.icon)?_c('icon',{attrs:{"name":menu.icon}}):_vm._e(),_vm._v(_vm._s(menu.label))],1)])}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.logout($event)}}},[_c('icon',{attrs:{"name":"power_settings_new"}}),_vm._v("Logout")],1)])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gXmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Option = function Option(text, value) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Option);

  this.text = text;
  this.value = value; // !value ? text : value
};

/* harmony default export */ __webpack_exports__["a"] = (Option);

/***/ }),

/***/ "infm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LetterAvatar_vue__ = __webpack_require__("33oq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5914ffc3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LetterAvatar_vue__ = __webpack_require__("2tzj");
function injectStyle (ssrContext) {
  __webpack_require__("SCOE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5914ffc3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LetterAvatar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5914ffc3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LetterAvatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jDP6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_Navigation_vue__ = __webpack_require__("30i9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_NavigationItem_js__ = __webpack_require__("SoRj");

//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('header', ['title', 'image', 'back', 'navigation'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('header', ['setHeaderBack'])),
  watch: {
    $route: function $route(to, from) {
      if (to.meta && to.meta.breadcrumb) {
        if (Array.isArray(to.meta.breadcrumb) && this.$_.find(to.meta.breadcrumb, { 'name': from.name })) {
          var target = this.$_.find(to.meta.breadcrumb, { 'name': from.name });
          this.setHeaderBack({ back: new __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_NavigationItem_js__["a" /* default */]({ label: target.text, href: target.name, params: from.params }) });
        } else if (to.meta.breadcrumb.name) {
          if (from.name === 'SiteList') {
            this.setHeaderBack({ back: new __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_NavigationItem_js__["a" /* default */]({ label: to.meta.breadcrumb.text, href: to.meta.breadcrumb.name, params: from.params, query: from.query }) });
          } else {
            this.setHeaderBack({ back: new __WEBPACK_IMPORTED_MODULE_3__lib_transfer_objects_NavigationItem_js__["a" /* default */]({ label: to.meta.breadcrumb.text, href: to.meta.breadcrumb.name, params: from.params }) });
          }
        }
      } else {
        this.setHeaderBack({});
      }
    }
  },
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_2__components_generics_Navigation_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "kLTP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mq+R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var MenuItem = function () {
  function MenuItem(_ref) {
    var label = _ref.label,
        href = _ref.href,
        _ref$icon = _ref.icon,
        icon = _ref$icon === undefined ? undefined : _ref$icon,
        _ref$subMenus = _ref.subMenus,
        subMenus = _ref$subMenus === undefined ? [] : _ref$subMenus,
        _ref$badge = _ref.badge,
        badge = _ref$badge === undefined ? 0 : _ref$badge,
        _ref$key = _ref.key,
        key = _ref$key === undefined ? '' : _ref$key;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MenuItem);

    this.key = key;
    this.label = label;
    this.href = href;
    this.active = false;
    this.icon = icon;
    this.badge = badge;

    subMenus.forEach(function (item) {
      if (!(item instanceof MenuItem)) {
        throw new Error('Invalid submenu item given, must be an instance of MenuItem.');
      }
    });

    this.subMenu = subMenus;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MenuItem, [{
    key: 'isActive',
    value: function isActive() {
      return this.active === true;
    }
  }, {
    key: 'hasSubMenu',
    value: function hasSubMenu() {
      return this.subMenu.length > 0;
    }
  }]);

  return MenuItem;
}();

/* harmony default export */ __webpack_exports__["a"] = (MenuItem);

/***/ }),

/***/ "noix":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"top"},[_c('drawer-menu'),_vm._v(" "),_c('user-menu'),_vm._v(" "),_c('pushed-menu')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nxk6":
/***/ (function(module, exports) {

module.exports = {
  plural: function plural(singularWord, count) {
    var pluralSuffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 's';

    var isPlural = count > 1;
    return singularWord + (isPlural === true ? pluralSuffix : '');
  }
};

/***/ }),

/***/ "nyIQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user != null)?_c('div',[_c('ul',{staticClass:"pushed-menu d-lg-block d-none"},_vm._l((_vm.currentPushedApps),function(menu,index){return _c('li',{key:index,class:['nav-item', menu.isActive() ? 'active' : '', menu.hasSubMenu() ? 'has-sub-menu' : '']},[_c('a',{attrs:{"href":menu.href}},[(menu.icon)?_c('icon',{attrs:{"name":menu.icon}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"align-middle"},[_vm._v(_vm._s(menu.label))]),(menu.badge > 0)?_c('b-badge',{staticClass:"ml-1  align-middle",attrs:{"pill":"","variant":"danger"}},[_vm._v(_vm._s(menu.badge))]):_vm._e()],1),_vm._v(" "),(menu.hasSubMenu())?_c('ul',{staticClass:"sub-menu"},_vm._l((menu.subMenu),function(sub,subIndex){return _c('li',{key:index+subIndex},[_c('a',{attrs:{"href":sub.href}},[(sub.icon)?_c('icon',{attrs:{"name":sub.icon}}):_vm._e(),_vm._v(_vm._s(sub.label))],1)])})):_vm._e()])})),_vm._v(" "),_c('div',{staticClass:"d-lg-none d-block"},[_c('b-navbar',{attrs:{"toggleable":"lg","type":"dark"}},[_c('b-navbar-brand',{attrs:{"href":"#"}},[_c('a',{attrs:{"href":"#"}},[(_vm.user)?_c('LetterAvatar',{staticClass:"profile-picture",attrs:{"initials":_vm.user.initials()}}):_vm._e(),_vm._v(" "),(_vm.user && _vm.user.role)?_c('span',{staticClass:"username"},[_vm._v(_vm._s(_vm.user.lastname)+" "+_vm._s(_vm.user.firstname)),_c('br'),_vm._v("\r\n          ("+_vm._s(_vm.user.role.libelle)+")")]):_vm._e()],1)]),_vm._v(" "),_c('b-navbar-toggle',{attrs:{"target":"nav-collapse"}}),_vm._v(" "),_c('b-collapse',{attrs:{"id":"nav-collapse","is-nav":""}},[_c('b-navbar-nav',[_vm._l((_vm.currentPushedApps),function(menu,index){return _c('b-nav-item',{key:index,class:['nav-item', menu.isActive() ? 'active' : '', menu.hasSubMenu() ? 'has-sub-menu' : ''],attrs:{"href":menu.href}},[(menu.icon)?_c('icon',{attrs:{"name":menu.icon}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"align-middle"},[_vm._v(_vm._s(menu.label))]),(menu.badge > 0)?_c('b-badge',{staticClass:"ml-1  align-middle",attrs:{"pill":"","variant":"danger"}},[_vm._v(_vm._s(menu.badge))]):_vm._e()],1)}),_vm._v(" "),_c('b-nav-item',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.logout($event)}}},[_c('icon',{attrs:{"name":"power_settings_new"}}),_vm._v("Logout")],1)])],2)],1)],1)],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oO4G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_menu_UserMenu__ = __webpack_require__("qlvc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_DrawerMenu__ = __webpack_require__("SwXt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_menu_PushedMenu__ = __webpack_require__("b67i");
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TopBar',
  components: {
    UserMenu: __WEBPACK_IMPORTED_MODULE_0__components_menu_UserMenu__["a" /* default */],
    DrawerMenu: __WEBPACK_IMPORTED_MODULE_1__components_menu_DrawerMenu__["a" /* default */],
    PushedMenu: __WEBPACK_IMPORTED_MODULE_2__components_menu_PushedMenu__["a" /* default */]
  }
});

/***/ }),

/***/ "qN3X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("jDP6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bcb10f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("wpGY");
function injectStyle (ssrContext) {
  __webpack_require__("kLTP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bcb10f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qlvc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__ = __webpack_require__("UV+H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_444f4ad8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__ = __webpack_require__("gFaA");
function injectStyle (ssrContext) {
  __webpack_require__("BVXj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-444f4ad8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_444f4ad8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rKSk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * Alert property container
 */
var Alert = function () {
  function Alert(title) {
    var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Alert);

    this.id = new Date().getTime();
    this.title = title;
    this.description = description;
    this.priority = priority;
    this.duration = duration;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Alert, [{
    key: "isEphemeral",
    value: function isEphemeral() {
      return this.duration !== null;
    }
  }]);

  return Alert;
}();

/* harmony default export */ __webpack_exports__["a"] = (Alert);

/***/ }),

/***/ "rmBI":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "siN1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u2BP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REFRESH_BADGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REFRESH_ABILITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_CALL_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_CALL_COMPLETE; });
/* unused harmony export EXPORT_CSV */

var REFRESH_BADGES = 'REFRESH_BADGES';
var REFRESH_ABILITIES = 'REFRESH_ABILITIES';
var API_CALL_PENDING = 'API_CALL_PENDING';
var API_CALL_COMPLETE = 'API_CALL_COMPLETE';
var EXPORT_CSV = 'EXPORT_CSV';

/***/ }),

/***/ "uCnY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w+5m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_transfer_objects_Alert__ = __webpack_require__("rKSk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Alert_vue__ = __webpack_require__("yL53");
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AlertContainer',
  components: {
    AlertComponent: __WEBPACK_IMPORTED_MODULE_1__components_Alert_vue__["a" /* default */]
  },
  data: function data() {
    return {
      alerts: []
    };
  },
  created: function created() {
    var _this = this;

    this.$bus.$on('alert', function (alert) {
      if (!(alert instanceof __WEBPACK_IMPORTED_MODULE_0__lib_transfer_objects_Alert__["a" /* default */])) {
        throw new Error('Invalid parameter, must be a Alert instance');
      }
      _this.alerts.push(alert);
    });
  }
});

/***/ }),

/***/ "wpGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:['main-header', _vm.image === null ? 'without-image' : '', _vm.image]},[(_vm.back && _vm.back.label)?_c('router-link',{attrs:{"to":{ name: _vm.back.href, params: _vm.back.params, query: _vm.back.query}}},[_c('Icon',{attrs:{"name":"arrow_back"}}),_c('span',{staticClass:"onglet"},[_vm._v(_vm._s(_vm.back.label))])],1):_vm._e(),_vm._v(" "),(_vm.title)?_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.navigation && _vm.navigation.length > 0)?_c('Navigation',{attrs:{"actions":_vm.navigation}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_Header__ = __webpack_require__("qN3X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layouts_TopBar__ = __webpack_require__("ZGzS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AlertContainer__ = __webpack_require__("R939");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_enums_events_app__ = __webpack_require__("u2BP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_actions_counter__ = __webpack_require__("8Yka");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__resources_ability__ = __webpack_require__("BIVg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_enums_alert__ = __webpack_require__("Jeu4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_transfer_objects_Alert__ = __webpack_require__("rKSk");



//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__("hKoQ").polyfill(); // compatibilité IE










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      pendingApiRequest: 0
    };
  },

  components: {
    Header: __WEBPACK_IMPORTED_MODULE_3__components_layouts_Header__["a" /* default */],
    TopBar: __WEBPACK_IMPORTED_MODULE_4__components_layouts_TopBar__["a" /* default */],
    AlertContainer: __WEBPACK_IMPORTED_MODULE_5__components_AlertContainer__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])({
    currentUser: 'user'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])('header', ['navigation']), {
    loading: function loading() {
      return this.pendingApiRequest > 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])(['setBadges']), {
    dashboardSummary: function dashboardSummary() {
      var _this = this;

      this.$administrationApi.get('/dashboard/summary').then(function (response) {
        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_7__store_actions_counter__["a" /* COUNTER_UPDATE */], response.data);
        _this.setBadges();
      }).catch(function (error) {
        console.error('error', error);
        _this.$bus.$emit('alert', new __WEBPACK_IMPORTED_MODULE_11__lib_transfer_objects_Alert__["a" /* default */]('Impossible de récupérer la liste des compteurs', 'une erreur s\'est produite lors de la récupération des compteurs. Veuillez réessayer.', __WEBPACK_IMPORTED_MODULE_10__lib_enums_alert__["a" /* HIGH */], 15000));
      });
    }
  }),
  watch: {
    currentUser: {
      deep: true,
      immediate: true,
      handler: function handler(newVal) {
        if (newVal) {
          this.$bus.$emit(__WEBPACK_IMPORTED_MODULE_6__lib_enums_events_app__["b" /* REFRESH_BADGES */]);
        }
      }
    }
  },
  created: function created() {
    var thatVue = this;
    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_6__lib_enums_events_app__["a" /* REFRESH_ABILITIES */], function (user) {
      var ability = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__resources_ability__["a" /* default */])(user.role.code);
      this.$ability.update(ability.rules);
    });
    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_6__lib_enums_events_app__["b" /* REFRESH_BADGES */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$auth.isAuthenticated().then(function (response) {
                thatVue.dashboardSummary();
              });

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    })));
    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_6__lib_enums_events_app__["c" /* API_CALL_PENDING */], function () {
      thatVue.pendingApiRequest++;
    });
    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_6__lib_enums_events_app__["d" /* API_CALL_COMPLETE */], function () {
      thatVue.pendingApiRequest--;
    });
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    [__WEBPACK_IMPORTED_MODULE_6__lib_enums_events_app__["a" /* REFRESH_ABILITIES */], __WEBPACK_IMPORTED_MODULE_6__lib_enums_events_app__["b" /* REFRESH_BADGES */], __WEBPACK_IMPORTED_MODULE_6__lib_enums_events_app__["c" /* API_CALL_PENDING */], __WEBPACK_IMPORTED_MODULE_6__lib_enums_events_app__["d" /* API_CALL_COMPLETE */]].forEach(function (element) {
      _this2.$bus.$off(element);
    });
  }
});

/***/ }),

/***/ "xTyH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Option__ = __webpack_require__("gXmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);




var all = 'Tous';

var Filter = function () {
  function Filter(_ref) {
    var _ref$selected = _ref.selected,
        selected = _ref$selected === undefined ? null : _ref$selected,
        _ref$firstOptionText = _ref.firstOptionText,
        firstOptionText = _ref$firstOptionText === undefined ? null : _ref$firstOptionText,
        _ref$options = _ref.options,
        options = _ref$options === undefined ? [] : _ref$options;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Filter);

    this.selected = selected; // selected || all
    this.firstOptionItem = firstOptionText !== null ? new __WEBPACK_IMPORTED_MODULE_2__Option__["a" /* default */](firstOptionText, null) : new __WEBPACK_IMPORTED_MODULE_2__Option__["a" /* default */](all, all);
    this.values = [this.firstOptionItem].concat(options);
    // console.log('options', options)
    // console.log('values', this.values)
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Filter, [{
    key: 'applyPermissions',
    value: function applyPermissions(allowedValues) {
      if (allowedValues == null || allowedValues.length === 0) {
        this.values = [];
      } else {
        this.values = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.values, function (o) {
          return allowedValues.includes(o.value);
        });
      }
      this.values = [this.firstOptionItem].concat(this.values);
    }
  }, {
    key: 'isPlaceholder',
    get: function get() {
      return this.firstOptionItem.value === this.selected;
    }
  }]);

  return Filter;
}();

/* harmony default export */ __webpack_exports__["a"] = (Filter);

/***/ }),

/***/ "xyfb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VALIDATION_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VALIDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOCKED; });
var VALIDATION_PENDING = 'VALIDATION_PENDING';
var VALIDATED = 'VALIDATED';
var LOCKED = 'LOCKED';

/***/ }),

/***/ "yL53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__ = __webpack_require__("zvUr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11239763_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__ = __webpack_require__("DEPO");
function injectStyle (ssrContext) {
  __webpack_require__("cyJc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11239763_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yLEp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return USER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_LOGOUT; });
var USER_REQUEST = 'USER_REQUEST';
var USER_SUCCESS = 'USER_SUCCESS';
var USER_ERROR = 'USER_ERROR';
var USER_LOGOUT = 'USER_LOGOUT';

/***/ }),

/***/ "zb8x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main-app"}},[_c('TopBar'),_vm._v(" "),_c('Header'),_vm._v(" "),(_vm.navigation && _vm.navigation.length > 0)?_c('b-breadcrumb',{attrs:{"items":_vm.navigation}}):_vm._e(),_vm._v(" "),_c('AlertContainer'),_vm._v(" "),_c('main',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader",attrs:{"src":__webpack_require__("rmBI")}}),_vm._v(" "),_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zvUr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_transfer_objects_Alert__ = __webpack_require__("rKSk");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AlertComponent',
  props: {
    alert: {
      type: __WEBPACK_IMPORTED_MODULE_0__lib_transfer_objects_Alert__["a" /* default */],
      required: true
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.visible = true;
    }, 100);

    if (this.alert.isEphemeral() === true) {
      setTimeout(function () {
        _this.close();
      }, this.alert.duration);
    }
  },

  methods: {
    close: function close() {
      var _this2 = this;

      this.visible = false;
      setTimeout(function () {
        _this2.$emit('remove', _this2.alert);
      }, 500);
    }
  }
});

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.2ef31d3726f7163b77e0.js